import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04d21c6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  "aria-label": "breadcrumb"
}
const _hoisted_2 = { class: "breadcrumb" }
const _hoisted_3 = { class: "breadcrumb-item" }

import { ref } from 'vue';
    import { BreadcrumbItem } from '@/types/BreadcrumbItem';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'Breadcrumbs',
  props: {
    items: null
  },
  setup(__props: any) {

const props = __props as {
        items: BreadcrumbItem[]
    }

    

    const items = ref(props.items || []);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (items.value.length)
    ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
        _createElementVNode("ol", _hoisted_2, [
          _createElementVNode("li", _hoisted_3, [
            _createVNode(_component_router_link, {
              to: "/",
              class: "accent-3--link accent-3 text-decoration-none"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Start")
              ]),
              _: 1
            })
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value.filter(x => !x.active), (item) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "breadcrumb-item",
              key: item.path
            }, [
              _createVNode(_component_router_link, {
                to: { path: item.path.startsWith('/') ? item.path : '/' + item.path },
                class: "accent-3--link accent-3 text-decoration-none"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.name), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items.filter(x => x.active), (item) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "breadcrumb-item active",
              "aria-current": "page",
              key: item.path
            }, _toDisplayString(item.name), 1))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})